export default __webpack_public_path__ + "static/media/flecha-plus.7452ece6.svg";